import axios from "axios";
import {
  fetchHODMessagesStart,
  fetchHODMessagesSuccess,
  fetchHODMessagesFailure,
  addHODMessageStart,
  addHODMessageSuccess,
  addHODMessageFailure,
  deleteHODMessageStart,
  deleteHODMessageSuccess,
  deleteHODMessageFailure,
  updateHODMessageStart,
  updateHODMessageSuccess,
  updateHODMessageFailure

} from "../slicer/hodMessagesSlice";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
// Fetch HOD messages
export const fetchHODMessages = (departmentId) => async (dispatch) => {
  dispatch(fetchHODMessagesStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getHoDMessages?departmentId=${departmentId}`,
      getAuthHeaders() // Added authentication headers
    );
    console.log(response.data); // Log the response to see the data
    dispatch(fetchHODMessagesSuccess(response.data.data));
  } catch (error) {
    dispatch(
      fetchHODMessagesFailure(
        error.response?.data?.message || "Failed to fetch HOD messages"
      )
    );
  }
};

export const addHODMessage = (messageInfo) => async (dispatch) => {
  dispatch(addHODMessageStart());
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/addHoDMessages`,
      messageInfo,
      getAuthHeaders() // Added authentication headers
    );
    // Validate the response
    const newMessage = response.data.data;
    if (
      newMessage &&
      newMessage.department_id &&
      newMessage.message &&
      newMessage.staff_id
    ) {
      dispatch(addHODMessageSuccess(newMessage));
    } else {
      throw new Error("Invalid HOD message data returned from API");
    }
  } catch (error) {
    dispatch(
      addHODMessageFailure(
        error.response?.data?.message || "Failed to add HOD message"
      )
    );
  }
};


// Delete an HOD message
export const deleteHODMessage = (id) => async (dispatch) => {
  dispatch(deleteHODMessageStart());
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/deleteHODMessage/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(deleteHODMessageSuccess(id));
  } catch (error) {
    dispatch(
      deleteHODMessageFailure(
        error.response?.data?.message || "Failed to delete HOD message"
      )
    );
  }
};

// Updated Redux action for updating HOD messages
export const updateHODMessage = (messageInfo, id) => async (dispatch) => {
  dispatch(updateHODMessageStart());
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/updateHoDMessages/${id}`,
      messageInfo,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateHODMessageSuccess(response.data.data));
  } catch (error) {
    dispatch(
      updateHODMessageFailure(
        error.response?.data?.message || "Failed to update HOD message"
      )
    );
  }
};